import { Label } from '@/components/shadcn/label'

export function CompactViewToggleV2({
  compactMode,
  setCompactMode,
  inline = false,
}: {
  compactMode: boolean
  setCompactMode: (compactMode: boolean) => void
  /** When true, omits absolute positioning for use inside flex/grid layouts (e.g. Triangle axis row). */
  inline?: boolean
}) {
  const isCompactMode = compactMode === true

  const handleToggle = () => {
    setCompactMode(!isCompactMode)
  }

  return (
    <div
      className={
        inline
          ? 'flex items-center gap-x-1 justify-self-end px-1 py-0.5'
          : 'absolute right-[8px] top-5 z-[10] flex translate-y-[calc(-100%)] items-center gap-x-1 px-1 py-0.5'
      }
    >
      <button
        type="button"
        aria-label="Toggle compact view"
        aria-pressed={isCompactMode}
        className="peer inline-flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full border border-transparent bg-input p-0.5 transition-colors"
        data-state={isCompactMode ? 'checked' : 'unchecked'}
        onClick={handleToggle}
      >
        <span
          className="bg-offwhite pointer-events-none block h-3 w-3 rounded-full shadow-sm transition-transform"
          style={{ transform: `translateX(${isCompactMode ? '12px' : '0px'})` }}
        />
      </button>
      <Label onClick={handleToggle} className="cursor-pointer text-xs font-light text-foreground/70">
        Compact View
      </Label>
    </div>
  )
}
